<template>
<div class="footer">
	<div class="container">
		<div class="logo">
			<img src="../assets/firma.png">
		</div>

		<div class="row" id>
	  		


	        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 patrocinio">
	          <a href="http://remo.com/team/member/yilmer-vivas/" target="_blank"><img src="../assets/remo.png"></a>
	          <img src="../assets/cravioto.png">
	        </div>
	        
      </div>
    </div>
	
    



    <div class="final">
      contac me info@yilmervivas.com <br>
    	© 2018, All Rights Reserved
    </div>
</div>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
     
    }
  }
}

</script>

<style scoped>
.footer {
  margin-top: 100px;
  width: 100%;
  background-color: #000000;
}
.logo{
	padding-top:20px;
	text-align: center;
}
.final{
	text-align: center;
	margin-top: 20px
}
.patrocinio{
	text-align: center;
	margin-top: 15px;

}
.pa{
	color: white;
	font-size: 13px;
	font-weight: lighter;
	margin-top: 10px;
	text-align: center;
	opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/YilmerFooter.vue